import { isFuture, parse, subYears } from 'date-fns';
import { useContext, useMemo } from 'react';

import { AuthContext } from '../../../../../contexts/AuthContext';

export const useGetFiscalYearStart = () => {
  const { apiUser } = useContext(AuthContext);

  return useMemo(() => {
    let dateStart = parse(
      `${apiUser?.settings?.global?.['fiscal-year-start'] || 'January'}/01/${new Date().getFullYear()}`,
      'MMMM/dd/yyyy',
      new Date(),
    );
    if (isFuture(dateStart)) {
      dateStart = subYears(dateStart, 1);
    }
    return dateStart;
  }, [apiUser?.settings?.global]);
};
